var render, staticRenderFns
import script from "./MValidationTranslate.vue?vue&type=script&lang=ts&"
export * from "./MValidationTranslate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5edd715c')) {
      api.createRecord('5edd715c', component.options)
    } else {
      api.reload('5edd715c', component.options)
    }
    
  }
}
component.options.__file = "src/mixins/MValidationTranslate.vue"
export default component.exports